import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-profile-complete',
  templateUrl: './profile-complete.component.html',
  styleUrls: ['./profile-complete.component.css']
})
export class ProfileCompleteComponent implements OnInit {

  constructor(private titleService: Title, ) {
    this.titleService.setTitle("TheRentalGuys.Ca - Profile Complete");
  }

  ngOnInit() {
  }

}
